// extracted by mini-css-extract-plugin
export var tooltipArrow = "N1iOtYDfFcNB86jLWhho";
export var tooltipArrowInner = "BJLt8lHdFHv04Z_3eDkn";
export var tooltipContent = "vguPWmLCWGycGKvjkaxs";
export var tooltipRoot = "qCxUgx08CvbCIN3nxwAU";